<template>
    <div class="ListComponent-MAIN" v-if="active">
        <div class="list-backdrop" @click="$emit('close')"></div>

        <section class="list-panel">
            <header>
                <h3>Guardar en...</h3>
                <button @click="$emit('close')">×</button>
            </header>

            <p v-if="loading">Cargando listas...</p>

            <div 
                class="list-option" 
                v-for="list in lists" 
                :key="list.id"
                @click="toggleList(list)"
            >
                <input 
                    type="checkbox" 
                    :checked="isChecked(list.id)"
                    readonly
                />

                <span>{{ list.name }}</span>
            </div>

            <p v-if="!loading && !lists.length">
                Aún no tienes listas.
            </p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ListComponent',

    props: {
        active: {
            type: Boolean,
            default: false
        },
        itemType: {
            type: String,
            required: true
        },
        itemId: {
            type: [Number, String],
            required: true
        }
    },

    emits: ['close'],

    data() {
        return {
            lists: [],
            checkedListIds: [],
            loading: false
        }
    },

    watch: {
        active(value) {
            if(value) this.fetchLists();
        }
    },

    methods: {
        getAuthHeaders() {
            return {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            };
        },

        isChecked(listId) {
            return this.checkedListIds.includes(Number(listId));
        },

        async fetchLists() {
            try {
                this.loading = true;

                const response = await fetch(`${this.$ENDPOINT}/api/my-lists.php`, {
                    method: 'GET',
                    headers: this.getAuthHeaders()
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.lists = result.lists || [];

                    // Necesitamos saber en cuáles listas ya está guardado.
                    await this.fetchCheckedLists();
                }

            } catch(error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async fetchCheckedLists() {
            this.checkedListIds = [];

            for(const list of this.lists) {
                const response = await fetch(`${this.$ENDPOINT}/api/detail.php?id=${list.id}`, {
                    method: 'GET',
                    headers: this.getAuthHeaders()
                });

                const result = await response.json();

                if(result.status === 'success') {
                    const items = result.items || [];

                    const exists = items.some(item => 
                        item.item_type === this.itemType &&
                        Number(item.item_id) === Number(this.itemId)
                    );

                    if(exists) {
                        this.checkedListIds.push(Number(list.id));
                    }
                }
            }
        },

        async toggleList(list) {
            const checked = this.isChecked(list.id);

            if(checked) {
                await this.removeItem(list.id);
            } else {
                await this.addItem(list.id);
            }
        },

        async addItem(listId) {
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/add-item.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        list_id: listId,
                        item_type: this.itemType,
                        item_id: Number(this.itemId)
                    })
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.checkedListIds.push(Number(listId));
                }

            } catch(error) {
                console.error(error);
            }
        },

        async removeItem(listId) {
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/remove-item.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        list_id: listId,
                        item_type: this.itemType,
                        item_id: Number(this.itemId)
                    })
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.checkedListIds = this.checkedListIds.filter(id => id !== Number(listId));
                }

            } catch(error) {
                console.error(error);
            }
        }
    }
}
</script>

<style scoped lang="stylus">
.ListComponent-MAIN
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100vh
    z-index: 999
    background-color: rgba(0, 0, 0, 0.5)

.list-backdrop
    width: 100%
    height: 100%

.list-panel
    position: fixed
    left: 0
    right: 0
    bottom: 0
    max-height: 70vh
    overflow-y: auto
    padding: 20px
    border-radius: 20px 20px 0 0
    background-color: white

    >header
        display: flex
        align-items: center
        justify-content: space-between
        margin-bottom: 20px

        >h3
            margin: 0
            font-family: "Archivo ExtraCondensed", sans-serif
            font-size: 8vw

        >button
            border: none
            background-color: transparent
            font-size: 32px

.list-option
    display: flex
    align-items: center
    gap: 15px
    padding: 12px 0
    font-family: "Archivo ExtraCondensed", sans-serif
    font-size: 6vw

    >input
        width: 24px
        height: 24px
        accent-color: #015aff
</style>

<!--
Uso desde otro componente

<ListComponent
    :active="listModal.active"
    :item-type="listModal.itemType"
    :item-id="listModal.itemId"
    @close="listModal.active = false"
/>
-->